export enum RequestStatus {
  pending = 0,
  loading = 1,
  loaded = 2,
  failed = 3,
}